import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "HeaderSearchBox" })
export default class HeaderSearchBox extends Vue {
    public searchText: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.clear();
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public clear() {
        this.searchText = null;
    }

    public showAll() {
        if (!this.searchText) {
            this.searchText = "";
        }

        (<any>window).location = this.routes.Search_List + "?searchtext=" + this.searchText;
    }
};